var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Row, Col, AccordionSet, Accordion, KeyValue, MultiColumnList, Button, TextLink, } from "@folio/stripes/components";
import { useIntl } from "react-intl";
import { useOkapiKy, useCallout } from "@folio/stripes/core";
import { useQuery } from "react-query";
import { ProductAccessibilityEnum } from "../../types/Api";
import { fetchProductById } from "../../api/productService";
import { fetchProductNumbersByProductId } from "../../api/productNumberService";
import { ProductMeasuresTable } from "../../components/ProductMeasuresTable";
import { ProductExtentsTable } from "../../components/ProductExtentsTable";
import { CopyableId } from "../../components/CopyableId";
import { PublicCatalogLink } from "../../components/PublicCatalogLink";
import { useCanAssignProductNumber } from "../../hooks/useCanAssignProductNumber";
import { formatPriceForDisplay } from "../../utils/priceUtils";
import { isForbiddenError } from "../../utils/httpErrors";
var settle = function (promise) { return __awaiter(void 0, void 0, void 0, function () {
    var error_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                _a = {};
                return [4 /*yield*/, promise];
            case 1: return [2 /*return*/, (_a.value = _b.sent(), _a.failed = false, _a.forbidden = false, _a)];
            case 2:
                error_1 = _b.sent();
                // Reported to the user as one error callout for the whole table, except a
                // 403 which only means the related product is not visible to this user.
                return [2 /*return*/, { failed: true, forbidden: isForbiddenError(error_1) }];
            case 3: return [2 /*return*/];
        }
    });
}); };
var getProductDetailPath = function (id) { return "/bragency/products/detail/".concat(id); };
var ProductDetail = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7;
    var productProp = _a.product;
    var location = useLocation();
    var history = useHistory();
    var ky = useOkapiKy();
    var formatMessage = useIntl().formatMessage;
    var callout = useCallout();
    var searchParams = new URLSearchParams(location.search);
    var productId = searchParams.get("detail");
    var _8 = useQuery(["product", productId], function () { return fetchProductById(ky, productId); }, {
        enabled: !!productId && !productProp,
    }), fetchedProduct = _8.data, isLoading = _8.isLoading;
    var product = productProp || fetchedProduct;
    var _9 = useCanAssignProductNumber(product), canAssignProductNumber = _9.canAssignProductNumber, productNumbersData = _9.productNumbersData;
    var relatedProductIds = ((_b = product === null || product === void 0 ? void 0 : product.productsRelations) === null || _b === void 0 ? void 0 : _b.map(function (relation) { return relation.relatedProductId; }).filter(function (id) { return !!id; })) || [];
    var relatedProductsData = useQuery(["relatedProducts", relatedProductIds], function () {
        return Promise.all(relatedProductIds.map(function (id) { return __awaiter(void 0, void 0, void 0, function () {
            var _a, relatedProduct, numbers;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            settle(fetchProductById(ky, id)),
                            settle(fetchProductNumbersByProductId(ky, id)),
                        ])];
                    case 1:
                        _a = _c.sent(), relatedProduct = _a[0], numbers = _a[1];
                        if (relatedProduct.forbidden) {
                            return [2 /*return*/, { id: id, hasError: false, forbidden: true }];
                        }
                        return [2 /*return*/, {
                                id: id,
                                product: relatedProduct.value,
                                productNumbers: numbers.failed
                                    ? undefined
                                    : ((_b = numbers.value) === null || _b === void 0 ? void 0 : _b.items) || [],
                                hasError: relatedProduct.failed || numbers.failed,
                            }];
                }
            });
        }); }));
    }, {
        enabled: relatedProductIds.length > 0,
        onSuccess: function (data) {
            if (data.some(function (related) { return related.hasError; })) {
                callout === null || callout === void 0 ? void 0 : callout.sendCallout({
                    type: "error",
                    message: formatMessage({
                        id: "ui-br-agency.product.relatedProducts.loadError",
                    }),
                });
            }
        },
    }).data;
    if ((!productId && !productProp) || isLoading || !product) {
        return null;
    }
    var publisherName = ((_f = (_e = (_d = (_c = product.title) === null || _c === void 0 ? void 0 : _c.titlePublishers) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.publisher) === null || _f === void 0 ? void 0 : _f.name) || "-";
    var firstContributor = ((_j = (_h = (_g = product.title) === null || _g === void 0 ? void 0 : _g.titleContributions) === null || _h === void 0 ? void 0 : _h.find(function (c) { return c.person; })) === null || _j === void 0 ? void 0 : _j.firstName) &&
        ((_m = (_l = (_k = product.title) === null || _k === void 0 ? void 0 : _k.titleContributions) === null || _l === void 0 ? void 0 : _l.find(function (c) { return c.person; })) === null || _m === void 0 ? void 0 : _m.lastName)
        ? "".concat((_q = (_p = (_o = product.title) === null || _o === void 0 ? void 0 : _o.titleContributions) === null || _p === void 0 ? void 0 : _p.find(function (c) { return c.person; })) === null || _q === void 0 ? void 0 : _q.firstName, " ").concat((_t = (_s = (_r = product.title) === null || _r === void 0 ? void 0 : _r.titleContributions) === null || _s === void 0 ? void 0 : _s.find(function (c) { return c.person; })) === null || _t === void 0 ? void 0 : _t.lastName)
        : ((_w = (_v = (_u = product.title) === null || _u === void 0 ? void 0 : _u.titleContributions) === null || _v === void 0 ? void 0 : _v.find(function (c) { return c.person; })) === null || _w === void 0 ? void 0 : _w.name) || "-";
    var selectedTitleName = ((_y = (_x = product.title) === null || _x === void 0 ? void 0 : _x.names) === null || _y === void 0 ? void 0 : _y.find(function (n) { var _a; return ((_a = n.type) === null || _a === void 0 ? void 0 : _a.value) === "01"; })) ||
        ((_0 = (_z = product.title) === null || _z === void 0 ? void 0 : _z.names) === null || _0 === void 0 ? void 0 : _0[0]);
    var titleName = (selectedTitleName === null || selectedTitleName === void 0 ? void 0 : selectedTitleName.name) || "-";
    var getAccessibilityLabel = function (accessibility) {
        if (accessibility === ProductAccessibilityEnum.PUBLIC) {
            return formatMessage({ id: "ui-br-agency.product.accessibility.PUBLIC" });
        }
        return formatMessage({ id: "ui-br-agency.product.accessibility.PRIVATE" });
    };
    var renderRelatedProductNumbers = function (relatedProductId, productNumbers) {
        if (!relatedProductId || !productNumbers) {
            return "-";
        }
        var openDetail = function () {
            return history.push(getProductDetailPath(relatedProductId));
        };
        if (productNumbers.length === 0) {
            return (React.createElement(TextLink, { onClick: openDetail }, formatMessage({
                id: "ui-br-agency.product.relatedProducts.noNumber",
            })));
        }
        return productNumbers.map(function (productNumber, index) { return (React.createElement(React.Fragment, { key: productNumber.id || index },
            index > 0 && ", ",
            React.createElement(TextLink, { onClick: openDetail }, productNumber.fullFormattedValue))); });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.product.accordion.general",
                }) },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: formatMessage({
                                id: "ui-br-agency.product.title.publisher.label",
                            }), value: publisherName }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: formatMessage({
                                id: "ui-br-agency.product.title.title.label",
                            }), value: firstContributor && firstContributor !== "-"
                                ? "".concat(firstContributor, ": ").concat(titleName)
                                : titleName }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: formatMessage({
                                id: "ui-br-agency.product.folioId.label",
                            }), value: React.createElement(React.Fragment, null,
                                React.createElement(CopyableId, { value: product.id }),
                                React.createElement(PublicCatalogLink, { record: product, notPublicMessageId: "ui-br-agency.publicCatalog.product.notPublic" })) })),
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: formatMessage({
                                id: "ui-br-agency.product.titleFolioId.label",
                            }), value: React.createElement(CopyableId, { value: (_1 = product.title) === null || _1 === void 0 ? void 0 : _1.id }) }))),
                (selectedTitleName === null || selectedTitleName === void 0 ? void 0 : selectedTitleName.partNumber) && (React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: formatMessage({
                                id: "ui-br-agency.title.names.partNumber.label",
                            }), value: selectedTitleName.partNumber })))),
                (selectedTitleName === null || selectedTitleName === void 0 ? void 0 : selectedTitleName.partName) && (React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: formatMessage({
                                id: "ui-br-agency.title.names.partName.label",
                            }), value: selectedTitleName.partName })))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: formatMessage({
                                id: "ui-br-agency.product.primaryContentType.field.label",
                            }), value: ((_2 = product.primaryContentType) === null || _2 === void 0 ? void 0 : _2.description) || "-" }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: formatMessage({
                                id: "ui-br-agency.product.form.field.label",
                            }), value: ((_3 = product.form) === null || _3 === void 0 ? void 0 : _3.description) || "-" }))),
                product.formDetails && product.formDetails.length > 0 && (React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(KeyValue, { label: formatMessage({
                                id: "ui-br-agency.product.formDetails.label",
                            }), value: product.formDetails
                                .map(function (fd) { var _a; return (_a = fd.value) === null || _a === void 0 ? void 0 : _a.description; })
                                .filter(Boolean)
                                .join(", ") || "-" }))))),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.product.accordion.measures",
                }) },
                React.createElement(ProductMeasuresTable, { unitMeasures: product.unitMeasures, cartonMeasures: product.cartonMeasures, palletMeasures: product.palletMeasures })),
            product.extents && product.extents.length > 0 && (React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.product.accordion.extents",
                }) },
                React.createElement(ProductExtentsTable, { extents: product.extents }))),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.product.accordion.product",
                }) },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: formatMessage({
                                id: "ui-br-agency.product.composition.field.label",
                            }), value: ((_4 = product.composition) === null || _4 === void 0 ? void 0 : _4.description) || "-" }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: formatMessage({
                                id: "ui-br-agency.product.publishingStatus.field.label",
                            }), value: ((_5 = product.publishingStatus) === null || _5 === void 0 ? void 0 : _5.description) || "-" }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: formatMessage({
                                id: "ui-br-agency.product.publishingDate.field.label",
                            }), value: product.publishingDate || "-" }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: formatMessage({
                                id: "ui-br-agency.product.copyrightFrom.field.label",
                            }), value: product.copyrightFrom || "-" })),
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: formatMessage({
                                id: "ui-br-agency.product.copyrightTo.field.label",
                            }), value: product.copyrightTo || "-" })))),
            product.price && (React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.product.accordion.price",
                }) },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(KeyValue, { label: formatMessage({
                                id: "ui-br-agency.product.price.detail.label",
                            }), value: "".concat(product.price.amount != null
                                ? formatPriceForDisplay(product.price.amount)
                                : "-", " ").concat(((_6 = product.price.currency) === null || _6 === void 0 ? void 0 : _6.value) || "", " (").concat(((_7 = product.price.type) === null || _7 === void 0 ? void 0 : _7.description) || "-", ")") }))))),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.product.accordion.accessibility",
                }) },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: formatMessage({
                                id: "ui-br-agency.product.accessibility.field.label",
                            }), value: getAccessibilityLabel(product.accessibility) })))),
            product.productsRelations && product.productsRelations.length > 0 && (React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.product.accordion.relatedProducts",
                }) },
                React.createElement(MultiColumnList, { contentData: product.productsRelations
                        .filter(function (relation) {
                        var _a;
                        return !((_a = relatedProductsData === null || relatedProductsData === void 0 ? void 0 : relatedProductsData.find(function (data) { return data.id === relation.relatedProductId; })) === null || _a === void 0 ? void 0 : _a.forbidden);
                    })
                        .map(function (relation) {
                        var _a, _b, _c, _d, _e, _f, _g;
                        var related = relatedProductsData === null || relatedProductsData === void 0 ? void 0 : relatedProductsData.find(function (data) { return data.id === relation.relatedProductId; });
                        var relatedProduct = related === null || related === void 0 ? void 0 : related.product;
                        return {
                            relationType: ((_a = relation.relationType) === null || _a === void 0 ? void 0 : _a.description) || "-",
                            publisher: ((_c = (_b = relatedProduct === null || relatedProduct === void 0 ? void 0 : relatedProduct.title) === null || _b === void 0 ? void 0 : _b.owner) === null || _c === void 0 ? void 0 : _c.name) || "-",
                            title: ((_f = (_e = (_d = relatedProduct === null || relatedProduct === void 0 ? void 0 : relatedProduct.title) === null || _d === void 0 ? void 0 : _d.names) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.name) || "-",
                            productForm: ((_g = relatedProduct === null || relatedProduct === void 0 ? void 0 : relatedProduct.form) === null || _g === void 0 ? void 0 : _g.description) || "-",
                            productNumber: renderRelatedProductNumbers(relation.relatedProductId, related === null || related === void 0 ? void 0 : related.productNumbers),
                        };
                    }), visibleColumns: [
                        "relationType",
                        "publisher",
                        "title",
                        "productForm",
                        "productNumber",
                    ], columnMapping: {
                        relationType: formatMessage({
                            id: "ui-br-agency.product.relationType.label",
                        }),
                        publisher: formatMessage({
                            id: "ui-br-agency.product.publisher.label",
                        }),
                        title: formatMessage({
                            id: "ui-br-agency.product.title.label",
                        }),
                        productForm: formatMessage({
                            id: "ui-br-agency.product.product.label",
                        }),
                        productNumber: formatMessage({
                            id: "ui-br-agency.product.productNumber.label",
                        }),
                    }, interactive: false }))),
            React.createElement(Accordion, { label: formatMessage({
                    id: "ui-br-agency.product.accordion.productNumbers",
                }) },
                React.createElement(MultiColumnList, { contentData: ((productNumbersData === null || productNumbersData === void 0 ? void 0 : productNumbersData.items) || []).map(function (productNumber) {
                        var _a;
                        return ({
                            productNumber: productNumber.fullFormattedValue,
                            publisher: ((_a = productNumber.publisher) === null || _a === void 0 ? void 0 : _a.name) || "-",
                            note: productNumber.note || "",
                        });
                    }), visibleColumns: ["productNumber", "publisher", "note"], columnMapping: {
                        productNumber: formatMessage({
                            id: "ui-br-agency.product.productNumbers.label",
                        }),
                        publisher: formatMessage({
                            id: "ui-br-agency.product.publisher.label",
                        }),
                        note: formatMessage({
                            id: "ui-br-agency.product.productNumbers.note",
                        }),
                    }, interactive: false }),
                canAssignProductNumber && (React.createElement(Row, { style: { marginTop: "1rem" } },
                    React.createElement(Col, { xs: 12 },
                        React.createElement(Button, { buttonStyle: "primary", onClick: function () {
                                return history.push("/bragency/product-numbers/assign/".concat(product.id));
                            }, marginBottom0: true }, formatMessage({
                            id: "ui-br-agency.product.productNumbers.assign",
                        })))))))));
};
export default ProductDetail;
